module.exports = __webpack_public_path__ + "img/biter-die-1.e68270b7.png";